// extracted by mini-css-extract-plugin
export default {"checkbox":"DeleteClubAdminForm_checkbox__hoP51","checkboxText":"DeleteClubAdminForm_checkboxText__YICPL"};